"use client";
import AutoScrollSlider from "./autoscroll";

interface AnnouncementBannerProps {
  text?: string;
  speed?: number; // Animation duration in seconds
  bgColor?: string;
  textColor?: string;
  showGradient?: boolean;
  height?: string;
  fontSize?: string;
}

export default function AnnouncementBanner({
  text = "",
  speed = 20,
  bgColor = "#BE2330",
  textColor = "#FFFFFF",
  showGradient = false,
  height = "py-spacing-4",
  fontSize = "text-heading-10-semibold",
}: AnnouncementBannerProps) {
  if (!text) {
    return null;
  }

  return (
    <div
      className={`fixed top-0 left-0 right-0 w-full overflow-hidden z-50 ${height}`}
      style={{ backgroundColor: bgColor }}
    >
      <div className="w-full h-full">
        <AutoScrollSlider
          numberOfCards={1}
          showGradient={showGradient}
          animationDuration={speed}
          isPaused={false}
          gradientClassName="h-full w-16"
        >
          {[text].map((announcement, index) => (
            <div
              key={`announcement-${index}`}
              className="flex items-center justify-center px-8 mx-4 whitespace-nowrap"
            >
              <p
                className={`${fontSize} text-center`}
                style={{ color: textColor }}
              >
                {announcement}
              </p>
            </div>
          ))}
        </AutoScrollSlider>
      </div>
    </div>
  );
}
